import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Download, Eye } from "lucide-react";
import { api, errorMessage } from "@/lib/api";
import { fmtDate } from "@/lib/format";
import { fmtSize } from "@/lib/documents";
import { Panel, SectionLabel } from "@/components/common/ui-kit";
import { DocumentsPanel } from "@/components/documents/DocumentsPanel";
import { Button } from "@/components/ui/button";

const download = async (cid, d) => {
  try {
    const r = await api.get(`/companies/${cid}/documents/customer-view/${d.id}/download`, { responseType: "blob" });
    const url = URL.createObjectURL(r.data);
    const a = document.createElement("a"); a.href = url; a.download = d.filename; a.click();
    setTimeout(() => URL.revokeObjectURL(url), 2000);
  } catch (e) { toast.error(errorMessage(e)); }
};

// Tab Documenti dell'anagrafica: vista interna completa o vista cliente
export const CompanyDocsTab = ({ companyId }) => {
  const [cust, setCust] = useState(false);
  return (
    <div className="space-y-3">
      <div className="flex justify-end gap-2" data-testid="company-docs-mode">
        <Button size="sm" className="rounded-full" variant={cust ? "outline" : "default"} onClick={() => setCust(false)} data-testid="company-docs-internal">Vista interna</Button>
        <Button size="sm" className="rounded-full" variant={cust ? "default" : "outline"} onClick={() => setCust(true)} data-testid="company-docs-customer"><Eye className="mr-1 h-4 w-4" />Vista cliente</Button>
      </div>
      {cust ? <CustomerDocsView companyId={companyId} /> : <DocumentsPanel entityType="company" entityId={companyId} />}
    </div>
  );
};

// Vista cliente dell'anagrafica: solo documenti customer-safe del cliente, versione corrente, niente dati interni
export const CustomerDocsView = ({ companyId }) => {
  const [items, setItems] = useState(null);
  useEffect(() => { api.get(`/companies/${companyId}/documents/customer-view`).then((r) => setItems(r.data.items)).catch(() => setItems([])); }, [companyId]);
  if (!items) return null;
  return (
    <Panel className="p-5" data-testid="customer-docs-view">
      <SectionLabel><Eye className="mr-1 inline h-3.5 w-3.5" />Vista cliente · solo documenti customer-safe</SectionLabel>
      <ul className="mt-2 divide-y divide-line">{items.map((d) => <li key={d.id} className="flex items-center gap-3 py-2.5" data-testid={`customer-doc-${d.id}`}>
        <div className="min-w-0 flex-1"><p className="truncate text-sm font-semibold text-ink">{d.title}</p>
          <p className="text-xs text-slate-500">{d.number} · {d.category_label}{d.ddt_number ? ` · DDT ${d.ddt_number}` : ""} · {fmtSize(d.file_size)} · {fmtDate(d.date)}</p></div>
        <Button size="sm" variant="ghost" onClick={() => download(companyId, d)} data-testid={`customer-doc-download-${d.id}`}><Download className="h-4 w-4" /></Button></li>)}
        {!items.length && <li className="py-2 text-sm text-slate-500" data-testid="customer-docs-empty">Nessun documento condiviso con il cliente.</li>}</ul>
    </Panel>
  );
};
